import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="yk-site-footer">
            <div className="yk-footer-image" aria-hidden="true" style={{
                backgroundImage: 'url("https://stssevastorage.blob.core.windows.net/ykwebsite/background/footer-bg1.jpg")'
            }}></div>

            <div className="yk-footer-container">
                {/* <!--Widgets Section--> */}
                <div className="yk-footer-grid">
                    {/* <!--Column--> */}
                    <div className="yk-footer-brand">
                        <Link to="/" className="yk-footer-logo" aria-label="Yugal Kunj home">
                            <img src="https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png" alt="Yugal Kunj" loading="lazy" />
                        </Link>
                        <p className="yk-footer-about">Radha Madhav Society is part of the worldwide mission of Jagadguru Kripalu Parishat (JKP), a non-profit organization founded by Jagadguru Shree Kripalu ji Maharaj to provide a deeper understanding of true Hinduism and bring to light the wonderful resources of this eternal religion and its all-encompassing culture.</p>
                        <ul className="yk-footer-social" aria-label="Social media">
                            <li><a href="https://www.facebook.com/yugalkunj/" target="_blank" rel="noopener noreferrer" aria-label="Yugal Kunj on Facebook"><span className="fab fa-facebook-f" aria-hidden="true"></span></a></li>
                            <li><a href="https://twitter.com/search?q=yugalkunj" target="_blank" rel="noopener noreferrer" aria-label="Yugal Kunj on Twitter"><span className="fab fa-twitter" aria-hidden="true"></span></a></li>
                            <li><a href="https://www.yelp.com/biz/yugal-kunj-duluth-2" target="_blank" rel="noopener noreferrer" aria-label="Yugal Kunj on Yelp"><span className="fab fa-yelp" aria-hidden="true"></span></a></li>
                            <li><a href="https://www.instagram.com/yugal_kunj/" target="_blank" rel="noopener noreferrer" aria-label="Yugal Kunj on Instagram"><span className="fab fa-instagram" aria-hidden="true"></span></a></li>
                            <li><a href="https://video.search.yahoo.com/search/video;_ylt=AwrC1DGkf51cEi8A_gzQtDMD;_ylu=X3oDMTB0N2Noc21lBGNvbG8DYmYxBHBvcwMxBHZ0aWQDBHNlYwNwaXZz?p=yugal+kunj+duluth+ga&amp;fr2=piv-web&amp;fr=yfp-t-s" target="_blank" rel="noopener noreferrer" aria-label="Yugal Kunj videos on Yahoo"><span className="fab fa-yahoo" aria-hidden="true"></span></a></li>
                        </ul>
                    </div>

                    {/* <!--Column--> */}
                    {/* <!--Column--> */}
                    <nav className="yk-footer-nav" aria-labelledby="yk-footer-quick-heading">
                        <h3 id="yk-footer-quick-heading">Quick Links</h3>
                        <ul>
                            <li><Link to="/USA/Home">Home</Link></li>
                            <li><Link to="/USA/about">About Us</Link></li>
                            <li><a href="https://portalyk.yugalkunj.org/" target="_blank" rel="noopener noreferrer">classes</a></li>
                            <li><a href="https://portalyk.yugalkunj.org/" target="_blank" rel="noopener noreferrer">Visit Us</a></li>
                            <li><Link to="/USA/contact">Contact Us</Link></li>
                            <li><Link to="/USA/upcomingevents">Events</Link></li>
                        </ul>
                    </nav>

                    {/* <!--Column--> */}
                    {/* <!--   <div className="column col-lg-4 col-md-4 col-sm-12">
                          <div className="footer-widget links-widget">
                              <div className="widget-content">
                                  <h3>Our Partners</h3>
                                  <ul>
                                      <li><Link to="#">Donate Kausid</Link></li>
                                      <li><Link to="#">Save Our earth</Link></li>
                                      <li><Link to="#">Water Shortages</Link></li>
                                      <li><Link to="#">Recycle Better</Link></li>
                                      <li><Link to="#">Plant Trees Welfare</Link></li>
                                  </ul>
                              </div>
                          </div>
                      </div> --> */}
                    {/* <!--Column--> */}
                    <nav className="yk-footer-nav" aria-labelledby="yk-footer-useful-heading">
                        <h3 id="yk-footer-useful-heading">Useful Links</h3>
                        <ul>
                            <li><Link to="/USA/aboutdidiji">About Didi Ji</Link></li>
                            <li><Link to="/USA/videolectures">Video Lecture</Link></li>
                            <li><Link to="/USA/wordsofwisdom">Words of Wisdom</Link></li>
                            {/* <!--  <li><Link to="comingsoon.html">Join Our Programs</Link></li> --> */}
                            <li><Link to="/USA/templeactivities">Temple Activities</Link></li>
                            <li><Link to="/USA/activitycalendar">Yugal Kunj Calendar</Link></li>
                            <li><Link to="/USA/gallery">Gallery</Link></li>
                        </ul>
                    </nav>

                    <section className="yk-footer-contact" aria-labelledby="yk-footer-contact-heading">
                        <h3 id="yk-footer-contact-heading">Contact Us</h3>
                        <address>Yugal Kunj - Radha Krishna Temple and Community Center 2769 Duluth Hwy, Duluth, GA 30096</address>
                        <ul className="yk-footer-contact-links">
                            <li><a href="tel:678-920-6669"><span className="fa fa-phone-alt" aria-hidden="true"></span><span>Phone 678-920-6669</span></a></li>
                            <li><a href="mailto:info@yugalkunj.org"><span className="fa fa-envelope-open" aria-hidden="true"></span><span>info@yugalkunj.org</span></a></li>
                        </ul>
                        <div className="yk-footer-hours">
                            <h4>Temple Hours</h4>
                            {/* <li>Mon - Fri : 7:00 AM - 8:00 AM </li>
                                                    <li>Mon - Fri : 5:00 PM - 8:00 PM </li> */}
                            <p>Every Day 7:00 AM - 8:30 PM</p>
                        </div>
                    </section>
                    {/* <!--Column--> */}
                </div>

                {/* <!-- Footer Bottom --> */}
                <div className="yk-footer-bottom">
                    {/* <!--Copyright--> */}
                    <p>Copyrights (c) {currentYear} <Link to="/USA/Home">Yugal kunj </Link> All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
